import Compact from "./compact.vue";

export default Compact;
